import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, ComponentFactoryResolver } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CompleteApplicationData } from "./../../model/complete-application";
import { scrollTopChange } from "src/app/utilities/utilities.file";
import { SharedServiceService } from "src/app/services/shared-service.service";
import { WSCallDetailsData } from "src/app/model/creat-update-lead";
import { DataCapture } from "src/app/model/data-capture";
import { CompleteApplicationService } from 'src/app/services/complete-application.service';
import { IwService } from 'src/app/services/iw.service';
import { MatVerticalStepper } from '@angular/material/stepper';
import { ISTATACARD, GENERIC_ERROR, VALIDATION_MSG, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
declare var AmoScript: Function;
declare var form_next_click: Function;
declare var _satellite: any;
declare var analytics: any;

@Component({
  selector: "app-personal-details",
  templateUrl: "./personal-details.component.html",
  styleUrls: ["./personal-details.component.scss"]
})
export class PersonalDetailsComponent implements OnInit {
  personalCompleteForm: FormGroup;
  personalCompleteForm2: FormGroup;
  wsDetails = new WSCallDetailsData();
  elementPosition: any;
  arrowUp: boolean = true;
  qdeData: any;
  personalDetails = new DataCapture();
  qualificationDropdown: any;
  @ViewChild("matPersonalBlock") personalBlock: ElementRef;
  @ViewChild("stepper") stepper: MatVerticalStepper;
  residentialStatusDropdown: any;
  mailingDropdown: any;
  eapplyFormPostQDELabel: any;
  enableAccountNoField: boolean;
  enablePerAddField: boolean;
  caData: CompleteApplicationData;
  providedPin: any;
  city: any;
  state: any;
  resiStdCode: any;
  pinNotFound: boolean;
  @Input() masterData: any;
  autoPinCode: any;
  pinCompleteApp: any = {};
  companiesToSearch: any;
  pinList = [];
  filterPin: any[];
  expandProfessional: boolean = false;
  @Output() personaldetailsSectionValid = new EventEmitter<any>();
  @Output() personaldetailsSectionCompleted = new EventEmitter<any>();
  @Input() expandedPersonal: any;
  @Input() step: any = 0;
  stdCode: any;
  percentagePesonal: any = '0%';
  percentageRes: any = '0%';
  trackData: any;
  resultValue: boolean = true;
  personalDetailsStep: boolean;
  residentialDetailsStep: boolean;
  TATACARD = ISTATACARD;
  employmentDetailsStep: boolean;
  officeAddressStep: boolean;
  successPersonal: boolean;
  successResidential: boolean;
  errorPersonal: any;
  errorResidential: any;
  personalNextClicked: boolean;
  errorMessage: any;
  validationMsgs: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  fromSWIFTJourney: boolean;

  constructor(
    private fb: FormBuilder,
    private sharedData: SharedServiceService,
    private completeApp: CompleteApplicationService,
    private iw: IwService,
    private themeService: ThemeService
  ) {
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.fromSWIFTJourney = this.sharedData.fromSwiftJourney;
    this.validationMsgs = VALIDATION_MSG;
    this.qdeData = this.sharedData.qdeSubmitData;
    this.trackData = this.sharedData.trackApplicationResponse
    this.completeapplicationpart1Form();
    this.completeapplicationpart1Form2();
    this.qualificationDropdown = this.iw.geteapplyQualificationDCR();
    this.residentialStatusDropdown = this.iw.geteapplyResidentialDCR();
    this.mailingDropdown = this.iw.geteapplyMailingAddressDCR();
    if(!this.fromSWIFTJourney){
      if ((this.sharedData.qdeSubmitData && (this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "P" || this.sharedData.qdeSubmitData.WSCallUserOccupationCode == "T")) || (this.sharedData.trackApplicationResponse && (this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType == "P" || this.sharedData.trackApplicationResponse.eapplyEmploymentDetails.occupationType == "T"))) {
        this.mailingDropdown = this.mailingDropdown.filter(e => e.key_value != 'O');
      }
    }
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    this.personalCompleteForm.valueChanges.subscribe(v => {
      this.savePartialData();
    });
    this.personalCompleteForm2.valueChanges.subscribe(v => {
      this.savePartialData();
    });

    if (this.masterData) {
      this.companiesToSearch = this.masterData.companyList;
      let list: any;
      if ((this.sharedData.paramschannel && this.sharedData.paramschannel == '901') || sessionStorage.getItem('channelId') == '901') {
        list = this.masterData.bancaCityList;
      } else {
        list = this.masterData.cityList;
      }
      list.forEach(pinObj => { this.pinList.push(...pinObj.pin) });
      if (this.pinList) {
        this.pinList = this.pinList.filter((v, i, a) => a.indexOf(v) === i);
      }
    }

    this.f2.fcnpincode.valueChanges.subscribe(value => {
      if (value && value.length >= 2 && this.pinList) {
        this.filterPin = this.pinList.filter(pin => ('' + pin).startsWith(value));
      } else {
        this.filterPin = null;
      }
      this.fetchCityFromPin();
    });

    this.patchDetailsForTracking();
    this.patchDetailsForTracking2();
  }

  ngOnChanges() {
    if (this.masterData) {
      this.companiesToSearch = this.masterData.companyList;
      let list: any;
      if ((this.sharedData.paramschannel && this.sharedData.paramschannel == '901') || sessionStorage.getItem('channelId') == '901') {
        list = this.masterData.bancaCityList;
      } else {
        list = this.masterData.cityList;
      }
      list.forEach(pinObj => { this.pinList.push(...pinObj.pin) });
      if (this.pinList) {
        this.pinList = this.pinList.filter((v, i, a) => a.indexOf(v) === i);
      }
    }
  }

  completeapplicationpart1Form() {
    this.personalCompleteForm = this.fb.group({
      fcnFathersname: ["", [Validators.required, Validators.pattern("[A-Za-z\\s]*")]],
      fcnQualification: ["", [Validators.required]],
      fcnAlternetcardno: [""],
      fcnMotherMaidenName: ["", [Validators.required, Validators.pattern("[A-Za-z\\s]*")]],
      fcnExistingRelwithSBI: ["N"],
      fcnAccountno: [""]
    });
  }

  completeapplicationpart1Form2() {
    this.personalCompleteForm2 = this.fb.group({
      fcnResstatus: ["", [Validators.required, Validators.pattern("[^\\|<>\\?=;!\\*]*")]],
      fcnMailingaddress: ["", [Validators.required, Validators.pattern("O|R")]],
      fcnYearsinresidence: ["", [Validators.required]],
      fcnPerAddSameAsAbove: ['1'],
      fcnHouseno: ["", Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")],
      fcnLocality: ["", Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")],
      fcnAddresscontinue: ["", Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")],
      fcnpincode: [""]
    });
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.personalCompleteForm.controls[controlName].hasError(errorName);
  };

  get f() {
    return this.personalCompleteForm.controls;
  }

  get f2() {
    return this.personalCompleteForm2.controls;
  }

  numberOnlyPin1(event) {
    if (this.f2.fcnpincode && this.f2.fcnpincode.value.length < 1) {
      let regex1 = /[1-9]/;
      if (event.key.match(regex1)) {
        return true;
      } else {
        return false;
      }
    } else {
      let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
  }

  scrollTopChangePersonal() {
    scrollTopChange(this.personalBlock);
    this.expandedPersonal = false;
  }

  uparrow() {
    this.arrowUp = !this.arrowUp;
  }

  alphabetsOnly(event) {
    let regex = "[A-Za-z\\s]*";
    if (event.key.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  numberOnly(event) {
    let regex2 = /[0-9]/;
    if (event.key.match(regex2)) {
      return true;
    } else {
      return false;
    }
  }

  savePartialData() {
    this.personalDetails.fathersName = this.f.fcnFathersname ? this.f.fcnFathersname.value : '';
    this.personalDetails.qualification = this.f.fcnQualification ? this.f.fcnQualification.value : '';
    this.personalDetails.alternateCardNumber = this.f.fcnAlternetcardno ? this.f.fcnAlternetcardno.value : '';
    this.personalDetails.mothersName = this.f.fcnMotherMaidenName ? this.f.fcnMotherMaidenName.value : '';
    this.personalDetails.existingRelwithSBI = this.f.fcnExistingRelwithSBI ? this.f.fcnExistingRelwithSBI.value : '';
    this.personalDetails.sbiAccountNo = this.f.fcnAccountno ? this.f.fcnAccountno.value : '';
    this.personalDetails.resiStatus = this.f2.fcnResstatus ? this.f2.fcnResstatus.value : '';
    this.personalDetails.yearsAtCurrentResi = this.f2.fcnYearsinresidence ? this.f2.fcnYearsinresidence.value : '';
    this.personalDetails.preferredMailAddress = this.f2.fcnMailingaddress ? this.f2.fcnMailingaddress.value : '';
    this.personalDetails.isPermResiAddressSame = this.f2.fcnPerAddSameAsAbove ? this.f2.fcnPerAddSameAsAbove.value : '';
    if (this.f2.fcnPerAddSameAsAbove.value && this.f2.fcnPerAddSameAsAbove.value === '1') {
      this.personalDetails.perHouseNo = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserHouseNo : '';
      this.personalDetails.perLocality = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserLocality : '';
      this.personalDetails.perAddLine = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserAddressLine : '';
      this.personalDetails.permPinCode = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserResiPincode : '';
      this.personalDetails.perCity = this.sharedData.resiCity ? this.sharedData.resiCity : null;
    } else {
      this.personalDetails.perHouseNo = this.f2.fcnHouseno ? this.f2.fcnHouseno.value : '';
      this.personalDetails.perLocality = this.f2.fcnLocality ? this.f2.fcnLocality.value : '';
      this.personalDetails.perAddLine = this.f2.fcnAddresscontinue ? this.f2.fcnAddresscontinue.value : '';
      this.personalDetails.permPinCode = this.f2.fcnpincode ? this.f2.fcnpincode.value : '';
      this.personalDetails.perCity = this.city ? this.city : null;
    }
    this.completeApp.personalData = this.personalDetails;
    let personalValid = this.personalCompleteForm.valid && this.personalCompleteForm2.valid ? true : false;
    this.setPercentagePersonal();
    this.personaldetailsSectionValid.emit({ 'pValid': personalValid });
  }

  toggleAccountNumber() {
    if (this.f.fcnExistingRelwithSBI.value && this.f.fcnExistingRelwithSBI.value === 'Y') {
      this.enableAccountNoField = true;
      this.personalCompleteForm.get('fcnAccountno').setValidators(Validators.required);
    } else {
      this.personalCompleteForm.patchValue({
        fcnAccountno: ''
      });
      this.personalCompleteForm.get('fcnAccountno').markAsUntouched();
      this.personalCompleteForm.get('fcnAccountno').setValidators(null);
      this.personalCompleteForm.get('fcnAccountno').markAsPristine();
      this.enableAccountNoField = false;
    }
    this.personalCompleteForm.get('fcnAccountno').updateValueAndValidity();
    this.setPercentagePersonal();
  }

  fillPermanentAdd() {
    if (this.f2.fcnPerAddSameAsAbove.value && this.f2.fcnPerAddSameAsAbove.value === '1') {
      this.enablePerAddField = false;
      this.personalCompleteForm2.patchValue({
        fcnHouseno: '',
        fcnLocality: '',
        fcnAddresscontinue: '',
        fcnpincode: ''
      });
      this.personalCompleteForm2.get('fcnHouseno').markAsUntouched();
      this.personalCompleteForm2.get('fcnHouseno').markAsPristine();
      this.personalCompleteForm2.get('fcnHouseno').setValidators(null);
      this.personalCompleteForm2.get('fcnLocality').markAsUntouched();
      this.personalCompleteForm2.get('fcnLocality').markAsPristine();
      this.personalCompleteForm2.get('fcnLocality').setValidators(null);
      this.personalCompleteForm2.get('fcnAddresscontinue').markAsUntouched();
      this.personalCompleteForm2.get('fcnAddresscontinue').markAsPristine();
      this.personalCompleteForm2.get('fcnAddresscontinue').setValidators(null);
      this.personalCompleteForm2.get('fcnpincode').markAsUntouched();
      this.personalCompleteForm2.get('fcnpincode').markAsPristine();
      this.personalCompleteForm2.get('fcnpincode').setValidators(null);
    } else if (this.f2.fcnPerAddSameAsAbove.value && this.f2.fcnPerAddSameAsAbove.value === '0') {
      this.enablePerAddField = true;
      this.personalCompleteForm2.get('fcnHouseno').setValidators([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]);
      this.personalCompleteForm2.get('fcnLocality').setValidators([Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]);
      this.personalCompleteForm2.get('fcnAddresscontinue').setValidators(Validators.pattern("[A-Za-z0-9\\s'()#,-./]*"));
      this.personalCompleteForm2.get('fcnpincode').setValidators([Validators.required, Validators.pattern("^[1-9][0-9]{5}$")]);

      this.personalCompleteForm2.get('fcnHouseno').updateValueAndValidity();
      this.personalCompleteForm2.get('fcnLocality').updateValueAndValidity();
      this.personalCompleteForm2.get('fcnAddresscontinue').updateValueAndValidity();
      this.personalCompleteForm2.get('fcnpincode').updateValueAndValidity();
    }
    this.personalCompleteForm2.get('fcnHouseno').updateValueAndValidity();
    this.personalCompleteForm2.get('fcnLocality').updateValueAndValidity();
    this.personalCompleteForm2.get('fcnAddresscontinue').updateValueAndValidity();
    this.personalCompleteForm2.get('fcnpincode').updateValueAndValidity();
    this.setPercentagePersonal();
  }

  personalDetailsNext() {
    this.personalNextClicked = true;
    this.setApplicationData();

    this.personalDetailscompleted()
    if (IS_CAMPAIGN) {
      window["page"] = 'ev_dc_start';
      window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
      AmoScript();
    }
    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.fatherName_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.personalSection_details.fatherName_label
      } if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.qualification_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.personalSection_details.qualification_label
      } if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.alternateCard_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.personalSection_details.alternateCard_label
      } if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.MotherName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.personalSection_details.MotherName_label
      }
    }
    form_next_click(this.sharedData.cardName, 'Personal Details', labelsDisplay);

    /* Analytics added */
    // if (window['analytics']) {
    //   analytics.track('eapply__click__next__addition_personal_deatail', {
    //     'MODE_OF_CONVERSION': '',
    //     'IS_ORGANIC': 'N',
    //     'SOURCE_GEM_ID1': this.sharedData.paramsgemid1,
    //     'SOURCE_GEM_ID2': this.sharedData.paramsgemid2,
    //     'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
    //     'CHANNEL_NAME': this.sharedData.paramschannel,
    //     'JOURNEY_NAME': 'EAPPLY',
    //     'FIRST_NAME': this.qdeData.WSCallUserFirstName,
    //     'LAST_NAME': this.qdeData.WSCallUserLastName,
    //     'MIDDLE_NAME': this.qdeData.WSCallUserMiddleName,
    //     'EMAIL': this.qdeData.WSCallUserEmailId,
    //     'MOBILE_NO': this.qdeData.WSCallUserMobileNumber,
    //     'CITY': this.qdeData.WSCallUserCity,
    //     'COMPANY_NAME': this.qdeData.WSCallUserCompany,
    //     'DOB': this.qdeData.WSCallUserDOB,
    //     'DESIGNATION': this.wsDetails.WSCallUserDesignation,
    //     'ANNUAL_SALARY': this.wsDetails.WSCallUserAnnualIncomeValue,
    //     'OFFICE_PINCODE': this.wsDetails.WSCallUserOfficePincode,
    //     'pan': this.qdeData.WSCallUserPanNumber,
    //     'RESI_ADDRESS': this.wsDetails.WSCallUserAddressLine,
    //     'RESI_PINCODE': this.wsDetails.WSCallUserResiPincode,
    //     'OCCUPATION_TYPE': this.wsDetails.WSCallUserOccupationCode,
    //     'CARD_TYPE': this.sharedData.sbic_card_Type,
    //     'Alt_Credit_Card_no': this.f.fcnAlternetcardno.value,
    //     'Mothers_maiden_name': this.f.fcnMotherMaidenName.value,
    //     'Qualification': this.f.fcnQualification.value,
    //     'fathers_Name': this.f.fcnFathersname.value,

    //   });
    // }

  }

  personalDetailscompleted() {
    this.personalDetailsStep = this.percentagePesonal === '100%' ? true : false;
    this.residentialDetailsStep = this.percentageRes === '100%' ? true : false;
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  setApplicationData() {
    this.caData = new CompleteApplicationData();
    if(this.fromSWIFTJourney){
      this.caData.WSCallUserFeeCode = this.sharedData.feeCodeForDataCapture ? this.sharedData.feeCodeForDataCapture : (this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.productDetail ? this.sharedData.trackApplicationResponse.data.productDetail.feeCode : null);
    }
    else{
      this.caData.WSCallUserFeeCode = this.sharedData.feeCodeForDataCapture ? this.sharedData.feeCodeForDataCapture : (this.sharedData.trackApplicationResponse && this.sharedData.trackApplicationResponse.productDetail ? this.sharedData.trackApplicationResponse.productDetail.feeCode : null);
    }
    this.caData.WSCallUserFathersName = this.f.fcnFathersname ? this.f.fcnFathersname.value : '';
    this.caData.WSCallUserQualification = this.f.fcnQualification ? this.f.fcnQualification.value : '';
    this.caData.WSCallUserAltCardNumber = this.f.fcnAlternetcardno ? this.f.fcnAlternetcardno.value : '';
    this.caData.WSCallUserMothersName = this.f.fcnMotherMaidenName ? this.f.fcnMotherMaidenName.value : '';
    this.caData.WSCallUserSbiAccountNo = this.f.fcnAccountno ? this.f.fcnAccountno.value : '';
    this.caData.WSCallUserOffAddLine1 = this.f.fcnCurrentaddress ? this.f.fcnCurrentaddress.value : '';
    this.caData.WSCallUserPreferredMailAddress = this.f2.fcnMailingaddress ? this.f2.fcnMailingaddress.value : '';
    this.caData.WSCallUserResiStatus = this.f2.fcnResstatus ? this.f2.fcnResstatus.value : '';
    this.caData.WSCallUserYearsAtCurrentResi = this.f2.fcnYearsinresidence ? this.f2.fcnYearsinresidence.value : '';
    this.caData.WSCallUserIsPermResiAddressSame = this.f2.fcnPerAddSameAsAbove ? this.f2.fcnPerAddSameAsAbove.value : '';
    if (this.f2.fcnPerAddSameAsAbove && this.f2.fcnPerAddSameAsAbove.value === '1') {
      this.personalDetails.perHouseNo = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserHouseNo : '';
      this.personalDetails.perLocality = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserLocality : '';
      this.personalDetails.perAddLine = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserAddressLine : '';
      this.personalDetails.permPinCode = this.sharedData.qdeSubmitData ? this.sharedData.qdeSubmitData.WSCallUserResiPincode : '';
    } else {
      this.caData.WSCallUserPerHouseNo = this.f2.fcnHouseno ? this.f2.fcnHouseno.value : '';
      this.caData.WSCallUserPerLocality = this.f2.fcnLocality ? this.f2.fcnLocality.value : '';
      this.caData.WSCallUserPerAddLine = this.f2.fcnAddresscontinue ? this.f2.fcnAddresscontinue.value : '';
      this.caData.WSCallUserResiPincode = this.f2.fcnpincode ? this.f2.fcnpincode.value : '';
    }
    if(this.fromSWIFTJourney){
      this.caData.WSCallUserApplicationNumber = this.sharedData.trackApplicationResponse.data ? this.sharedData.trackApplicationResponse.data.applicationNumber : (this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.applicationNumber ? this.sharedData.qdeSuccessResponse.applicationNumber : '');
    }
    else{
      this.caData.WSCallUserApplicationNumber = this.sharedData.trackApplicationResponse ? this.sharedData.trackApplicationResponse.applicationNumber : (this.sharedData.qdeSuccessResponse && this.sharedData.qdeSuccessResponse.applicationNumber ? this.sharedData.qdeSuccessResponse.applicationNumber : '');
    }   
    this.sharedData.cApersonalData = this.caData;
    console.log("cApersonalData ======>", this.sharedData.cApersonalData);
    let reqObj = Object.assign({}, this.sharedData.qdeSubmitData, this.caData, this.sharedData.cAadditionalData, this.sharedData.cAprofessisonalData, this.sharedData.cAadditionalCardFeatureData);
    reqObj = this.trimObject(reqObj);
    console.log("req obj from personal details component", reqObj);
    this.completeApp.saveUpdateApplication(reqObj).subscribe((result: any) => {
      console.log("result for saveUpdateApplication from personal details ==>",result);
      if (result && result.DataCaptureRes && result.DataCaptureRes.WSCallStatus && result.DataCaptureRes.WSCallStatus.toLowerCase() === 'success') {
        this.sharedData.dcSeqId = result.DataCaptureRes.WSCallSequenceId;
        this.personalNextClicked ? this.successPersonal = true : this.successResidential = true;
        if (this.personalNextClicked) {
          this.stepper.next();
          this.personalDetailscompleted();
        } else {
          console.log("Inside setApplicationData else block when personalNextClicked false from personal component");
          // this.step++;
          this.personaldetailsSectionCompleted.emit({
              expanded: true,
              steps: this.step,
            pValid: this.personalCompleteForm.valid && this.personalCompleteForm2.valid
          });
          this.sharedData.setProDetailsOpenState({ expand: true, step: 1 });
          // this.expandProfessional = true;
          // this.stepper.next();
          this.personalDetailscompleted()
        }
      } else {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
        console.log("Error Occured");
        if (this.personalNextClicked) {
          this.successPersonal = false;
          this.errorPersonal = GENERIC_ERROR;
        } else {
          this.successResidential = false;
          this.errorResidential = GENERIC_ERROR;
        }
      }
    }, (error) => {
      window["digitalData"].error = { message: GENERIC_ERROR };
      if (window['_satellite']) {
        _satellite.track('form_error');
      }
      if (this.personalNextClicked) {
        this.successPersonal = false;
        this.errorPersonal = GENERIC_ERROR;
      } else {
        this.successResidential = false;
        this.errorResidential = GENERIC_ERROR;
      }
    })
  }

  fetchCityFromPin() {
    if (this.f2.fcnpincode && this.f2.fcnpincode.value.length == 6 && this.masterData) {
      let cityList: any;
      if ((this.sharedData.paramschannel && this.sharedData.paramschannel == '901') || sessionStorage.getItem('channelId') == '901') {
        cityList = this.masterData.bancaCityList;
      } else {
        cityList = this.masterData.cityList;
      }

      this.providedPin = cityList.find(
        city => city.pin.includes(this.f2.fcnpincode.value) >= 1
      );
      this.city = this.providedPin ? this.providedPin.name : "";
      this.state = this.providedPin ? this.providedPin.state : "";
      this.stdCode = this.providedPin
        ? this.providedPin.std
          ? this.providedPin.std[0]
          : ""
        : "";
      this.completeApp.officeStdCode = this.stdCode;
      this.completeApp.officeCity = this.city;
    } else {
      this.providedPin = null;
      this.city = "";
      this.state = "";
      this.completeApp.officeStdCode = "";
      this.completeApp.officeCity = "";
    }
    this.sharedData.perState = this.state;
    if (this.f2.fcnPerAddSameAsAbove.value && this.f2.fcnPerAddSameAsAbove.value === '0') {
      this.providedPin ? this.personalCompleteForm2.get('fcnpincode').setErrors(null) : this.personalCompleteForm2.get('fcnpincode').setErrors({ 'pinNotFound': true });
    }
    this.setPercentagePersonal();
  }

  professionalExpand() {
    console.log('NEXT Clicked');
    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.fatherName_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.personalSection_details.fatherName_label
      } if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.qualification_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.personalSection_details.qualification_label
      } if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.alternateCard_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.personalSection_details.alternateCard_label
      } if (this.eapplyFormPostQDELabel.personalSection_details && this.eapplyFormPostQDELabel.personalSection_details.MotherName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.personalSection_details.MotherName_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.yearscurrentResidentail_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.yearscurrentResidentail_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.preferredmailAddress_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.preferredmailAddress_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.currentAddress_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.currentAddress_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.permanentAddress_Text) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.permanentAddress_Text
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.houseNo_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.houseNo_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.locality_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.locality_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.addressContinue_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.addressContinue_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label
      }
    }
    if (IS_CAMPAIGN) {
      window["page"] = 'ev_dc1';
      window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
      AmoScript();
    }
    form_next_click(this.sharedData.cardName, 'Personal Details', labelsDisplay);

    this.personalNextClicked = false;

    this.setApplicationData();
    // if (window['analytics']) {
    //   analytics.track('eapply__click__next__resdential_details', {
    //     'JOURNEY_NAME': 'EAPPLY',
    //     'IS_ORGANIC': 'N',
    //     'CARD_TYPE': this.sharedData.sbic_card_Type,
    //     'Current_residential_status': this.f2.fcnResstatus.value,
    //     'Years_in_current_residence': this.f2.fcnYearsinresidence.value,
    //     'Preferred_Mailing_address': this.f2.fcnMailingaddress.value,
    //     'is_same_permnt_addr_current_addr': this.f2.fcnPerAddSameAsAbove.value,
    //     'Permnt_addr_continue': this.f2.fcnAddresscontinue.value,
    //     'Permnt_addr_locality': this.f2.fcnLocality.value,
    //     'Permnt_addr_house_no': this.f2.fcnHouseno.value,
    //     'Permnt_addr_pincode': this.f2.fcnpincode.value,
    //     'pan': this.qdeData.WSCallUserPanNumber,
    //     'FIRST_NAME': this.qdeData.WSCallUserFirstName,
    //     'LAST_NAME': this.qdeData.WSCallUserLastName,
    //     'MIDDLE_NAME': this.qdeData.WSCallUserMiddleName,
    //     'EMAIL': this.qdeData.WSCallUserEmailId,
    //     'MOBILE_NO': this.qdeData.WSCallUserMobileNumber,
    //     'CITY': this.qdeData.WSCallUserCity,
    //     'COMPANY_NAME': this.qdeData.WSCallUserCompany,
    //     'DOB': this.qdeData.WSCallUserDOB,
    //   });
    // }

    /* Analytics added */

  }

  // setStep() {
  //   this.step = 0;
  //   this.personaldetailsSectionCompleted.emit({
  //     expanded: true,
  //     steps: this.step
  //   })
  // }

  setPercentagePersonal() {
    this.percentagePesonal = "0%";
    if (this.stepper.selectedIndex === 0) {
      if (this.f.fcnExistingRelwithSBI.value === "N") {
        let fathersPercent = this.f.fcnFathersname.valid ? 1 : 0;
        let qualificationPercent = this.f.fcnQualification.valid ? 1 : 0;
        let motherMaidenPercent = this.f.fcnMotherMaidenName.valid ? 1 : 0;
        let totalPercent = fathersPercent + qualificationPercent + motherMaidenPercent;
        totalPercent === 0 ? this.percentagePesonal = "0%" : true;
        totalPercent === 1 ? this.percentagePesonal = "33.33%" : true;
        totalPercent === 2 ? this.percentagePesonal = "66.67%" : true;
        totalPercent === 3 ? this.percentagePesonal = "100%" : true;
      } else if (this.f.fcnExistingRelwithSBI.value === "Y") {
        let fathersPercent = this.f.fcnFathersname.valid ? 1 : 0;
        let qualificationPercent = this.f.fcnQualification.valid ? 1 : 0;
        let accountPercent = this.f.fcnAccountno.valid ? 1 : 0;
        let totalPercent = fathersPercent + qualificationPercent + accountPercent;
        totalPercent === 0 ? this.percentagePesonal = "0%" : true;
        totalPercent === 1 ? this.percentagePesonal = "33.33%" : true;
        totalPercent === 2 ? this.percentagePesonal = "66.67" : true;
        totalPercent === 3 ? this.percentagePesonal = "100%" : true;
      }
    } else if (this.stepper.selectedIndex === 1) {
      if (this.f2.fcnPerAddSameAsAbove.value === "1") {
        let resPercent = this.f2.fcnResstatus.valid ? 1 : 0;
        let yearsPercent = this.f2.fcnYearsinresidence.valid ? 1 : 0;
        let mailPercent = this.f2.fcnMailingaddress.valid ? 1 : 0;
        let totalPercent = resPercent + yearsPercent + mailPercent;
        totalPercent === 0 ? this.percentageRes = "0%" : true;
        totalPercent === 1 ? this.percentageRes = "33.33%" : true;
        totalPercent === 2 ? this.percentageRes = "66.67" : true;
        totalPercent === 3 ? this.percentageRes = "100%" : true;
      } else if (this.f2.fcnPerAddSameAsAbove.value === "0") {
        let resPercent = this.f2.fcnResstatus.valid ? 1 : 0;
        let yearsPercent = this.f2.fcnYearsinresidence.valid ? 1 : 0;
        let mailPercent = this.f2.fcnMailingaddress.valid ? 1 : 0;
        let locPercent = this.f2.fcnLocality.valid ? 1 : 0;
        let housePercent = this.f2.fcnHouseno.valid ? 1 : 0;
        let pinPerecent = this.f2.fcnpincode.valid ? 1 : 0;
        let totalPercent = resPercent + yearsPercent + mailPercent + locPercent + housePercent + pinPerecent;
        totalPercent === 0 ? this.percentageRes = "0%" : true;
        totalPercent === 1 ? this.percentageRes = "16.67%" : true;
        totalPercent === 2 ? this.percentageRes = "33.33" : true;
        totalPercent === 3 ? this.percentageRes = "50%" : true;
        totalPercent === 4 ? this.percentageRes = "66.67%" : true;
        totalPercent === 5 ? this.percentageRes = "83.33%" : true;
        totalPercent === 6 ? this.percentageRes = "100%" : true;
      }
    }
  }

  patchDetailsForTracking() {
    if (this.sharedData.trackApplicationResponse) {
      if (this.fromSWIFTJourney) {
        console.log("trying to autoopopulate from patchDetailsForTracking in personal details");
        this.city = this.sharedData.trackApplicationResponse.data.contactDetails.resiCity
        this.state = this.sharedData.trackApplicationResponse.data.contactDetails.resiState
        this.personalCompleteForm.patchValue({
          // fcnFathersname: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.applicantDetails.wscallUserFathersName ? this.sharedData.trackApplicationResponse.data.applicantDetails.wscallUserFathersName : '',
          // fcnQualification: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.applicantDetails.wscallUserQualification ? this.sharedData.trackApplicationResponse.data.applicantDetails.wscallUserQualification : '',
          // fcnAlternetcardno: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.applicantDetails.wscallUserAltCardNumber ? this.sharedData.trackApplicationResponse.data.applicantDetails.wscallUserAltCardNumber : '',
          fcnFathersname: "",
          fcnQualification: "",
          fcnAlternetcardno: "",
          fcnMotherMaidenName: this.sharedData.trackApplicationResponse.data && this.sharedData.trackApplicationResponse.data.applicantDetails && this.sharedData.trackApplicationResponse.data.applicantDetails.mothersName ? this.sharedData.trackApplicationResponse.data.applicantDetails.mothersName : '',
        })
      }
      else {
        console.log("trying to autopopulate else from patchDetailsForTracking in personal  details");
        this.city = this.sharedData.trackApplicationResponse.eapplyContactDetails.resiCity
        this.state = this.sharedData.trackApplicationResponse.eapplyContactDetails.resiState
        this.personalCompleteForm.patchValue({
          fcnFathersname: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserFathersName ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserFathersName : '',
          fcnQualification: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserQualification ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserQualification : '',
          fcnAlternetcardno: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserAltCardNumber ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserAltCardNumber : '',
          fcnMotherMaidenName: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserMothersName ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserMothersName : '',
        })
      }


    }
  }

  patchDetailsForTracking2() {
    if (this.sharedData.trackApplicationResponse) {
      if (this.fromSWIFTJourney) {
        console.log("trying to autoopopulate from patchDetailsForTracking2 in personal details");
        this.city = this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offCity ? this.sharedData.trackApplicationResponse.data.officeAddress.offCity : ''
        this.state = this.sharedData.trackApplicationResponse.data.officeAddress && this.sharedData.trackApplicationResponse.data.officeAddress.offState ? this.sharedData.trackApplicationResponse.data.officeAddress.offState : ''
      }
      else {
        console.log("trying to autopopulate else from patchDetailsForTracking2 in personal  details");
        this.city = this.sharedData.trackApplicationResponse.eapplyContactDetails && this.sharedData.trackApplicationResponse.eapplyContactDetails.resiCity ? this.sharedData.trackApplicationResponse.eapplyContactDetails.resiCity : '';
        this.state = this.sharedData.trackApplicationResponse.eapplyContactDetails && this.sharedData.trackApplicationResponse.eapplyContactDetails.resiState ? this.sharedData.trackApplicationResponse.eapplyContactDetails.resiState : '';
        if (this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame == '1') {
          this.personalCompleteForm2.patchValue({
            fcnPerAddSameAsAbove: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame : '',
            fcnResstatus: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserResiStatus ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserResiStatus : '',
            fcnYearsinresidence: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserYearsAtCurrentResi ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserYearsAtCurrentResi : '',
            fcnMailingaddress: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPreferredMailAddress ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPreferredMailAddress : '',
            fcnHouseno: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserHouseNo ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserHouseNo : '',
            fcnLocality: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserLocality ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserLocality : '',
            fcnAddresscontinue: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.WSCallUserAddressLine ? this.sharedData.trackApplicationResponse.dataCaptureDetails.WSCallUserAddressLine : '',
            fcnpincode: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserResiPincode ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserResiPincode : '',
          })
        }

        if (this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame == '0') {
          this.personalCompleteForm2.patchValue({
            fcnPerAddSameAsAbove: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserIsPermResiAddressSame : '',
            fcnResstatus: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserResiStatus ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserResiStatus : '',
            fcnYearsinresidence: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserYearsAtCurrentResi ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserYearsAtCurrentResi : '',
            fcnMailingaddress: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPreferredMailAddress ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPreferredMailAddress : '',
            fcnHouseno: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPerHouseNo ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPerHouseNo : '',
            fcnLocality: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPerLocality ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPerLocality : '',
            fcnAddresscontinue: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPerAddLine ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPerAddLine : '',
            fcnpincode: this.sharedData.trackApplicationResponse.dataCaptureDetails && this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPermPinCode ? this.sharedData.trackApplicationResponse.dataCaptureDetails.wscallUserPermPinCode : '',
          })
        }
      }

    }
  }

  stepChanged(event, stepper) {
    stepper.selected.interacted = false;
  }

  modten(inputNum) {
    let digit, digits, flag, sum, _i, _len, _result;
    flag = true;
    sum = 0;
    digits = (inputNum.target.value + '').split('').reverse();
    for (_i = 0, _len = digits.length; _i < _len; _i++) {
      digit = digits[_i];
      digit = parseInt(digit, 10);
      if ((flag = !flag)) {
        digit *= 2;
      }
      if (digit > 9) {
        digit -= 9;
      }
      sum += digit;
    }
    if (sum % 10 === 0) {
      _result = true
    }
    else {
      _result = false;
    }
    this.resultValue = _result;
    this.resultValue ? this.personalCompleteForm.get('fcnAlternetcardno').setErrors(null) : this.personalCompleteForm.get('fcnAlternetcardno').setErrors({ 'invalidCard': true });
    return _result;
  }
}
